var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "form",
      staticClass: "copy-spider-dialog",
      attrs: {
        title: _vm.$t("Copy Spider"),
        visible: _vm.visible,
        width: "580px",
        "before-close": _vm.onClose
      }
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { "label-width": "160px", model: _vm.form } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("New Spider Name"), required: "" } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("New Spider Name") },
                model: {
                  value: _vm.form.name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "plain", size: "small" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                icon: _vm.isLoading ? "el-icon-loading" : "",
                disabled: _vm.isLoading
              },
              on: { click: _vm.onConfirm }
            },
            [_vm._v(" " + _vm._s(_vm.$t("Confirm")) + " ")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }